<button
  [type]="type"
  [class.dense]="dense"
  [style.justifyContent]="textAlign"
  [style.backgroundColor]="backgroundColor"
  [disabled]="isDisabled"
  [style.color]="color"
>
  <span *ngIf="icon || loading" class="pi" [ngClass]="displayIcon"></span>
  <span>{{ loading ? 'Salvando...' : text }}</span>
</button>
